/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = '';
      this.valList = []; // 追加コード：閲覧順取得用
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof(recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        if (val === null) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        this.valList.push(val); // 追加コード：閲覧順を記憶
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);
      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            // 追加コード：非同期で実行され表示順がランダムになるため、閲覧日時が近い順に並び替え
            const Lis = recommendations.querySelectorAll('.products > li');
            const valList = this.valList;
            const SortedLis = [];
            Lis.forEach(function(list){
              var Phandle = list.querySelector('quick-view').dataset.productHandle;
              for(var j=0; j < valList.length; j++){
                if(valList[j] == Phandle){
                  SortedLis[j] = list.outerHTML;
                }
              }
            })
              for(var k=0; k < SortedLis.length; k++){
                this.container.innerHTML += SortedLis[k];
              }
            // 追加コードここまで：非同期で実行され表示順がランダムになるため、閲覧日時が近い順に並び替え
            
            this.classList.add('product-recommendations--loaded');
          }

        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}